import styled from 'styled-components';

import { Column } from '../../shared/styles';

const NameColumn = styled(Column)`
  width: 30%;
`;

const SlugColumn = styled(Column)`
  width: 15%;
`;

const DescriptionColumn = styled(Column)`
  width: 40%;
`;

const ActionColumn = styled(Column)`
  width: 15%;
`;

export {
  ActionColumn,
  DescriptionColumn,
  NameColumn,
  SlugColumn,
};
